var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.notSuitable.length
    ? _c(
        "div",
        { staticClass: "preview__section", attrs: { id: "notSuitable" } },
        [
          _c("h3", { staticClass: "preview__title" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.translations.tourDescriptionNotSuitable.text) +
                "\n  "
            ),
          ]),
          _vm.tourNotSuitable.more
            ? [
                _vm._l(_vm.tourNotSuitable.start, function (suitable) {
                  return _c(
                    "div",
                    {
                      key: `suitable-${suitable.id}`,
                      staticClass: "preview__include",
                    },
                    [
                      _c("div", {
                        staticClass: "preview__dot preview__dot--orange",
                      }),
                      _c("span", { staticClass: "preview__include-text" }, [
                        _vm._v(_vm._s(suitable.description)),
                      ]),
                    ]
                  )
                }),
                !_vm.showTourNotSuitable
                  ? _c(
                      "span",
                      {
                        staticClass: "preview__read-more",
                        on: {
                          click: function ($event) {
                            _vm.showTourNotSuitable = true
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.translations.textReadMore.text))]
                    )
                  : _vm._e(),
                _vm.showTourNotSuitable
                  ? [
                      _vm._l(_vm.tourNotSuitable.more, function (suitable) {
                        return _c(
                          "div",
                          {
                            key: `suitable-${suitable.id}`,
                            staticClass: "preview__include",
                          },
                          [
                            _c("div", {
                              staticClass: "preview__dot preview__dot--orange",
                            }),
                            _c(
                              "span",
                              { staticClass: "preview__include-text" },
                              [_vm._v(_vm._s(suitable.description))]
                            ),
                          ]
                        )
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "preview__read-more",
                          on: {
                            click: function ($event) {
                              _vm.showTourNotSuitable = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.translations.textHide.text))]
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._l(_vm.tourNotSuitable, function (suitable) {
                return _c(
                  "div",
                  {
                    key: `suitable-${suitable.id}`,
                    staticClass: "preview__include",
                  },
                  [
                    _c("div", {
                      staticClass: "preview__dot preview__dot--orange",
                    }),
                    _c("span", { staticClass: "preview__include-text" }, [
                      _vm._v(_vm._s(suitable.description)),
                    ]),
                  ]
                )
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }